import api from './api';
import { Technician } from '../types/technician';

export function getTechnicians() {
    return api.get<{ data: Technician[] }>('/technicians');
}

export function getTechnicianByEmail(email: string) {
    return api.get<{ data: Technician }>(`/technicians/by-email/${email}`);
}

export function getTechnician(id: number) {
    return api.get<{ data: Technician }>(`/technicians/${id}`);
}

export function createTechnician(data: Omit<Technician, 'id' | 'created_at' | 'updated_at'>) {
    return api.post<{ data: Technician }>('/technicians', data);
}

export function updateTechnician(id: number, data: Partial<Technician>) {
    return api.put<{ data: Technician }>(`/technicians/${id}`, data);
}

export function deleteTechnician(id: number) {
    return api.delete<{ success: boolean }>(`/technicians/${id}`);
}

export default {
    getTechnicians,
    getTechnicianByEmail,
    getTechnician,
    createTechnician,
    updateTechnician,
    deleteTechnician
}; 